<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar tipo de vehículo" : "Nuevo tipo de vehículo" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{ editing ? "Datos del tipo de vehículo" : "Datos del nuevo tipo de vehículo" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Nombre *</label>
                    <input
                      id="name"
                      type="text"
                      v-model="form.name"
                      autocomplete="off"
                      placeholder="Ingresar nombre"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error':
                          $v.form.name.$error,
                      }"
                    />
                    <FormError
                      v-if="
                        $v.form.name.$error &&
                        !$v.form.name.required
                      "
                      message="Nombre es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="description">Descripción *</label>

                    <input
                      id="description"
                      type="text"
                      v-model="form.description"
                      autocomplete="off"
                      placeholder="Ingresar descripción"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error':
                          $v.form.description.$error,
                      }"
                    />

                    <FormError
                      v-if="$v.form.description.$error && !$v.form.description.required"
                      message="Descripción es requerida"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="capacity">Cantidad máxima de pasajeros *</label>
                    <input
                      id="capacity"
                      type="number"
                      v-model="form.capacity"
                      autocomplete="off"
                      placeholder="Ingresar cantidad máxima de pasajeros"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.capacity.$error,
                      }"
                    />
                    <FormError
                      v-if="
                        $v.form.capacity.$error && !$v.form.capacity.required
                      "
                      message="Cantidad máxima de pasajeros es requerida"
                    />
                    <FormError
                      v-if="
                        $v.form.capacity.$error && !$v.form.capacity.numeric
                      "
                      message="Capacidad debe ser un número"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="max_baggage">Cantidad máxima de maletas *</label>
                    <input
                      id="max_baggage"
                      type="number"
                      v-model="form.max_baggage"
                      autocomplete="off"
                      placeholder="Ingresar cantidad máxima de maletas"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.max_baggage.$error,
                      }"
                    />
                    <FormError
                      v-if="
                        $v.form.max_baggage.$error && !$v.form.max_baggage.required
                      "
                      message="Cantidad máxima de maletas es requerida"
                    />
                    <FormError
                      v-if="
                        $v.form.max_baggage.$error && !$v.form.max_baggage.numeric
                      "
                      message="Equipaje máximo debe ser un número"
                    />
                  </div>
                </div>

                <!-- <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="profile">Tipo de vehículo *</label>
                    <FormSelect
                      id="vehicleType"
                      :items="vehicleTypesList"
                      v-model="form.vehicleType"
                      defaultOption="Elegir tipo de vehículo"
                      :showError="$v.form.vehicleType.$error"
                    />

                    <FormError
                      v-if="
                        $v.form.vehicleType.$error &&
                        !$v.form.vehicleType.required
                      "
                      message="Vehículo es requerido"
                    />
                  </div>
                </div> -->

                <div class="col-md-12">
                  <div class="form-group-buttons text-right">
                    <router-link
                      :to="{ name: 'config-vehicle-type-list' }"
                      class="button button-light"
                    >
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError, Constants } from "wize-admin";

import { VehicleTypeService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  components: {
    FormError
  },
  data() {
    return {
      profileTypes: [
        LocalConstants.ProfileTypes.ADMIN,
        LocalConstants.ProfileTypes.SUPERVISOR,
      ],
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
      ],
      brandList: LocalConstants.VehicleBrands,
      vehicleTypesList: [
        LocalConstants.VehicleTypes.SEDAN,
        LocalConstants.VehicleTypes.MINI_BUS,
        LocalConstants.VehicleTypes.SUV,
        LocalConstants.VehicleTypes.VAN,
      ],
      propertyList: [
        LocalConstants.VehicleProperty.TRAVELCAB,
        LocalConstants.VehicleProperty.EXTERNAL,
      ],
      form: {
        name: null,
        description: null,
        max_baggage: null,
        // vehicleType: null,
        capacity: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      name: { required },
      description: { required },
      // vehicleType: { required },
      capacity: { required, numeric },
      max_baggage: { required, numeric }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {},
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
          description: String(this.form.description),
          capacity: parseInt(this.form.capacity),
          max_baggage: parseInt(this.form.max_baggage),
        };

        if (!this.editing) {
          await VehicleTypeService.save(data);

          this.$router.push({
            name: "config-vehicle-type-list",
          });
        } else {
          await VehicleTypeService.update(this.$route.params.id, data);
          this.load(this.$route.params.id);
        }

        Alert.success("Se almacenó la información correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await VehicleTypeService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
